<template>
  <section class="p-box">
    <Loading v-if="loading" />
    <template v-else>
      <template v-if="unreadNotificationWdays">
        <div class="p-box__body">
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">{{ $t('pages.companies.mailNotificationSetting.header') }}</h3>
            </header>
            <div class="p-box__body">
              <KkInfo>
                <p>{{ $t('pages.companies.mailNotificationSetting.info') }}</p>
              </KkInfo>
              <div class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="subscribe_checkbox"
                        :checked="!unsubscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribe()"
                      >
                      <label
                        class="c-radio__label"
                        for="subscribe_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="unsubscribe_checkbox"
                        :checked="unsubscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribe()"
                      >
                      <label
                        class="c-radio__label"
                        for="unsubscribe_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                  <div v-show="!unsubscribed" class="selectForm c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <div
                      class="selectForm__info"
                    >
                      {{ $t('pages.companies.mailNotificationSetting.selectWday') }}
                    </div>
                    <div class="p-formGrid__items">
                      <ul class="c-checkbox">
                        <li
                          v-for="(weekday, i) in weekdays.slice(1)"
                          :key="i + 1"
                          class="c-checkbox__item"
                        >
                          <input
                            :id="`${weekday}_checkbox`"
                            :checked="isSubscribedWday(i + 1)"
                            type="checkbox"
                            class="c-checkbox__input"
                            @change="changeSubscription(i + 1)"
                          >
                          <label class="c-checkbox__label c-formLabel" :for="`${weekday}_checkbox`">
                            {{ displayWeekday(weekday) }}
                          </label>
                        </li>
                        <li
                          class="c-checkbox__item"
                        >
                          <input
                            :id="`${weekdays[0]}_checkbox`"
                            :checked="isSubscribedWday(0)"
                            type="checkbox"
                            class="c-checkbox__input"
                            @change="changeSubscription(0)"
                          >
                          <label class="c-checkbox__label c-formLabel" :for="`${weekdays[0]}_checkbox`">
                            {{ displayWeekday(weekdays[0]) }}
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">{{ $t('pages.companies.mailNotificationSetting.keywordSection.header') }}</h3>
            </header>
            <div class="p-box__body">
              <KkInfo>
                <i18n-t keypath="pages.companies.mailNotificationSetting.keywordSection.info" tag="div">
                  <template #keyword_link>
                    <router-link :to="{ name: 'CompaniesManagementKeywords', params: { company_uuid: currentCompanyUuid } }">
                      {{ $t("pages.companies.mailNotificationSetting.keywordSection.keyword_link_label") }}
                    </router-link>
                  </template>
                </i18n-t>
              </KkInfo>
              <div v-if="wholeKeywords.length === 0">
                {{ $t("pages.companies.mailNotificationSetting.keywordSection.noItems") }}
              </div>
              <div v-else class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="keyword_usage_subscribe_checkbox"
                        :checked="!keywordUnsubscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribeKeywordUsage(wholeKeywords.map(keyword => keyword.id))"
                      >
                      <label
                        class="c-radio__label"
                        for="keyword_usage_subscribe_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="keyword_usage_unsubscribe_checkbox"
                        :checked="keywordUnsubscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribeKeywordUsage()"
                      >
                      <label
                        class="c-radio__label"
                        for="keyword_usage_unsubscribe_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                  <div v-show="!keywordUnsubscribed" class="selectForm">
                    <div
                      class="selectForm__info"
                    >
                      {{ $t('pages.companies.mailNotificationSetting.keywordSection.selectKeyword') }}
                    </div>
                    <div class="p-formGrid__items">
                      <ul class="c-checkbox keywordItems">
                        <li
                          v-for="keyword in showKeywords"
                          :key="keyword.id"
                          class="c-checkbox__item"
                        >
                          <input
                            :id="`checkbox_${keyword.id}`"
                            :checked="isSubscribedKeyword(keyword.id)"
                            type="checkbox"
                            class="c-checkbox__input"
                            @change="changeKeywordUsageSubscription(keyword.id)"
                          >
                          <label class="c-checkbox__label c-formLabel" :for="`checkbox_${keyword.id}`">
                            {{ keyword.rule }}
                          </label>
                        </li>
                      </ul>
                      <template v-if="wholeKeywords.length > defaultShowNumber" class="c-links">
                        <span class="c-links__item">
                          <a @click="toggleViewMoreKeyword()">
                            {{ $t(`pages.companies.mailNotificationSetting.keywordSection.${viewMoreKeyword ? 'viewLessText' : 'viewMoreText' }`) }}
                          </a>
                        </span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="p-box">
            <header class="p-box__header">
              <h3 class="p-box__title">{{ $t('pages.companies.mailNotificationSetting.blockGoogleUpdate.header') }}</h3>
            </header>
            <div class="p-box__body">
              <KkInfo>
                {{ $t('pages.companies.mailNotificationSetting.blockGoogleUpdate.info') }}
              </KkInfo>
              <div class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="block_google_update_subscribe_checkbox"
                        :checked="blockGoogleUpdate"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribeBlockGoogleUpdate()"
                      >
                      <label
                        class="c-radio__label"
                        for="block_google_update_subscribe_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="block_google_update_unsubscribe_checkbox"
                        :checked="!blockGoogleUpdate"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribeBlockGoogleUpdate()"
                      >
                      <label
                        class="c-radio__label"
                        for="block_google_update_unsubscribe_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <KkBox v-if="showOnlyOwnerAuthority" :title="$t('pages.companies.mailNotificationSetting.achievement.header')" class="achievementBox" border>
            <template #content>
              <KkInfo>
                {{ $t('pages.companies.mailNotificationSetting.achievement.info') }}
              </KkInfo>
              <ul class="c-checkbox">
                <li
                  v-for="achievementKey in filteredSupportedAchievementKeys"
                  :key="achievementKey"
                  class="c-checkbox__item"
                >
                  <KkCheckbox
                    :id="achievementKey"
                    v-model="achievement[achievementKey]"
                    :label="$t(`pages.companies.mailNotificationSetting.achievement.${achievementKey}`)"
                  />
                  <KkTooltip :is-visible="showedTooltipName === achievementKey"
                             top="16px"
                             left="-200px"
                             width="400px"
                             class="achievementBox__tooltip"
                             @show-tooltip="showedTooltipName = achievementKey"
                             @hide-tooltip="showedTooltipName = undefined"
                  >
                    {{ $t(`pages.companies.mailNotificationSetting.achievement.tooltips.${achievementKey}`) }}
                  </KkTooltip>
                </li>
              </ul>
            </template>
          </KkBox>
          <!-- レポートメール -->
          <KkBox :title="$t('pages.companies.mailNotificationSetting.report.header')" class="achievementBox" border>
            <template #content>
              <KkInfo>
                {{ $t('pages.companies.mailNotificationSetting.report.info') }}
              </KkInfo>
              <div class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="subscribe_report_checkbox"
                        :checked="report.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribeReport"
                      >
                      <label
                        class="c-radio__label"
                        for="subscribe_report_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="unsubscribe_report_checkbox"
                        :checked="!report.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribeReport"
                      >
                      <label
                        class="c-radio__label"
                        for="unsubscribe_report_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </KkBox>
          <!-- アンケート回答メール -->
          <KkBox v-if="providedFeaturesSurvey" :title="$t('pages.companies.mailNotificationSetting.custom_survey_store_answer.header')" class="achievementBox" border>
            <template #content>
              <KkInfo>
                {{ $t('pages.companies.mailNotificationSetting.custom_survey_store_answer.info') }}
              </KkInfo>
              <div class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="subscribe_custom_survey_store_answer_checkbox"
                        :checked="custom_survey_store_answer.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribeCustomSurveyStoreAnswer"
                      >
                      <label
                        class="c-radio__label"
                        for="subscribe_custom_survey_store_answer_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="unsubscribe_custom_survey_store_answer_checkbox"
                        :checked="!custom_survey_store_answer.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribeCustomSurveyStoreAnswer"
                      >
                      <label
                        class="c-radio__label"
                        for="unsubscribe_custom_survey_store_answer_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </KkBox>
          <!-- 連携媒体の情報更新エラー通知メール -->
          <KkBox v-if="showMoreThanEditorAuthority" :title="$t('pages.companies.mailNotificationSetting.rpaError.header')" class="achievementBox" border>
            <template #content>
              <KkInfo>
                {{ $t('pages.companies.mailNotificationSetting.rpaError.info') }}
              </KkInfo>
              <div class="form c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                    <span class="c-radio__item">
                      <input
                        id="subscribe_rpa_error_checkbox"
                        :checked="rpaError.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="subscribeRpaError"
                      >
                      <label
                        class="c-radio__label"
                        for="subscribe_rpa_error_checkbox"
                      >{{ $t('labels.subscribe') }}</label>
                    </span>
                    <span class="c-radio__item">
                      <input
                        id="unsubscribe_rpa_error_checkbox"
                        :checked="!rpaError.subscribed"
                        type="radio"
                        class="c-radio__input"
                        @change="unsubscribeRpaError"
                      >
                      <label
                        class="c-radio__label"
                        for="unsubscribe_rpa_error_checkbox"
                      >{{ $t('labels.unsubscribe') }}</label>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </KkBox>
          <!-- 承認機能メール -->
          <KkBox v-if="snsApprovalFlow || postApprovalFlow || replyApprovalFlow" :title="$t('pages.companies.mailNotificationSetting.approval.header')" class="achievementBox" border>
            <template #content>
              <KkBox v-if="snsApprovalFlow" :title="$t('pages.companies.mailNotificationSetting.approval.sns.header')" border>
                <template #content>
                  <KkInfo>
                    {{ $t('pages.companies.mailNotificationSetting.approval.sns.info') }}
                  </KkInfo>
                  <div class="form c-grid">
                    <div class="c-grid__items">
                      <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                        <span class="c-radio__item">
                          <input
                            id="subscribe_sns_approval_checkbox"
                            :checked="snsApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="subscribeSnsApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="subscribe_sns_approval_checkbox"
                          >{{ $t('labels.subscribe') }}</label>
                        </span>
                        <span class="c-radio__item">
                          <input
                            id="unsubscribe_sns_approval_checkbox"
                            :checked="!snsApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="unsubscribeSnsApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="unsubscribe_sns_approval_checkbox"
                          >{{ $t('labels.unsubscribe') }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </KkBox>
              <KkBox v-if="postApprovalFlow" :title="$t('pages.companies.mailNotificationSetting.approval.post.header')" class="achievementBox" border>
                <template #content>
                  <KkInfo>
                    {{ $t('pages.companies.mailNotificationSetting.approval.post.info') }}
                  </KkInfo>
                  <div class="form c-grid">
                    <div class="c-grid__items">
                      <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                        <span class="c-radio__item">
                          <input
                            id="subscribe_post_approval_checkbox"
                            :checked="postApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="subscribePostApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="subscribe_post_approval_checkbox"
                          >{{ $t('labels.subscribe') }}</label>
                        </span>
                        <span class="c-radio__item">
                          <input
                            id="unsubscribe_post_approval_checkbox"
                            :checked="!postApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="unsubscribePostApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="unsubscribe_post_approval_checkbox"
                          >{{ $t('labels.unsubscribe') }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </KkBox>
              <KkBox v-if="replyApprovalFlow" :title="$t('pages.companies.mailNotificationSetting.approval.reply.header')" class="achievementBox" border>
                <template #content>
                  <KkInfo>
                    {{ $t('pages.companies.mailNotificationSetting.approval.reply.info') }}
                  </KkInfo>
                  <div class="form c-grid">
                    <div class="c-grid__items">
                      <div class="c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
                        <span class="c-radio__item">
                          <input
                            id="subscribe_reply_approval_checkbox"
                            :checked="replyApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="subscribeReplyApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="subscribe_reply_approval_checkbox"
                          >{{ $t('labels.subscribe') }}</label>
                        </span>
                        <span class="c-radio__item">
                          <input
                            id="unsubscribe_reply_approval_checkbox"
                            :checked="!replyApproval.subscribed"
                            type="radio"
                            class="c-radio__input"
                            @change="unsubscribeReplyApproval"
                          >
                          <label
                            class="c-radio__label"
                            for="unsubscribe_reply_approval_checkbox"
                          >{{ $t('labels.unsubscribe') }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </KkBox>
            </template>
          </KkBox>
        </div>
        <footer class="p-box__footer">
          <div class="c-button c-button--right">
            <router-link
              :to="{ name: 'CompaniesDashboards', params: { company_uuid: currentCompanyUuid }}"
              class="c-button__item c-button__item--outline-cancel"
            >
              {{ $t('labels.cancel') }}
            </router-link>
            <button class="c-button__item c-button__item--primary" @click="onSubmit()">
              {{ $t('labels.save') }}
            </button>
          </div>
        </footer>
      </template>
      <div v-else class="p-box__body">
        <h2 class="c-pageTitle">
          {{ $t('pages.companies.mailNotificationSetting.notMember.title') }}
        </h2>
        <p>{{ $t('pages.companies.mailNotificationSetting.notMember.notice') }}</p>
        <div class="c-button c-button--left">
          <router-link
            :to="{ name: 'CompaniesManagementMembers', params: { company_uuid: currentCompanyUuid }}"
            class="c-button__item c-button__item--primary"
          >
            {{ $t('pages.companies.mailNotificationSetting.notMember.doConnect') }}
          </router-link>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import Loading from '../components/Loading.vue'
import { KkBox, KkCheckbox, KkTooltip } from '../components/base'
import { KkInfo } from '../components/ui'
import { week } from '../modules/regularHour'

export default {
  name: 'CompaniesMailNotificationSetting',
  components: {
    Loading,
    KkInfo,
    KkBox,
    KkTooltip,
    KkCheckbox,
  },
  data() {
    return {
      viewMoreKeyword: false,
      showedTooltipName: undefined,
    }
  },
  computed: {
    ...mapState({
      unreadNotificationWdays: state => state.companiesMailReceivable.unreadNotificationWdays,
      loading: state => state.companiesMailReceivable.loading,
      wholeKeywords: state => state.companiesMailReceivable.wholeKeywords,
      achievement: state => state.companiesMailReceivable.achievement,
      blockGoogleUpdate: state => state.companiesMailReceivable.blockGoogleUpdate,
      report: state => state.companiesMailReceivable.report,
      custom_survey_store_answer: state => state.companiesMailReceivable.custom_survey_store_answer,
      rpaError: state => state.companiesMailReceivable.rpaError,
      snsApproval: state => state.companiesMailReceivable.snsApproval,
      postApproval: state => state.companiesMailReceivable.postApproval,
      replyApproval: state => state.companiesMailReceivable.replyApproval
    }),
    ...mapGetters({
      unsubscribed: 'companiesMailReceivable/unsubscribed',
      keywordUnsubscribed: 'companiesMailReceivable/keywordUnsubscribed',
      isSubscribedWday: 'companiesMailReceivable/isSubscribedWday',
      isSubscribedKeyword: 'companiesMailReceivable/isSubscribedKeyword',
      achievementKeys: 'companiesMailReceivable/achievementKeys',
      showOnlyOwnerAuthority: 'companiesAccessibleApi/showOnlyOwnerAuthority',
      providedFeaturesReview: 'companiesCompany/providedFeaturesReview',
      providedFeaturesSurvey: 'companiesCompany/providedFeaturesSurvey',
      providedFeaturesAnalysisInsight: 'companiesCompany/providedFeaturesAnalysisInsight',
      postApprovalFlow: 'companiesCompany/postApprovalFlow',
      snsApprovalFlow: 'companiesCompany/snsApprovalFlow',
      replyApprovalFlow: 'companiesCompany/replyApprovalFlow',
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    weekdays() {
      return week
    },
    showKeywords() {
      return this.viewMoreKeyword ? this.wholeKeywords : this.wholeKeywords.slice(0, this.defaultShowNumber)
    },
    defaultShowNumber() {
      return 10
    },
    achievementKeyAndFeatureMap() {
      return new Map([
        ['insightActionBeyondLastMonthOnMonth', this.providedFeaturesAnalysisInsight],
        ['insightActionBeyondLastYearOnYear', this.providedFeaturesAnalysisInsight],
        ['totalReviewCount', this.providedFeaturesReview],
        ['increaseReviewAverage', this.providedFeaturesReview],
        ['reviewCountBeyondLastYear', this.providedFeaturesReview],
        ['totalCustomSurveyAnswerCount', this.providedFeaturesSurvey],
      ])
    },
    filteredSupportedAchievementKeys() {
      return this.achievementKeys.filter(achievementKey => this.achievementKeyAndFeatureMap.get(achievementKey))
    }
  },
  created() {
    this.readMailReceivable(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readMailReceivable: 'companiesMailReceivable/readMailReceivable',
      updateMailReceivable: 'companiesMailReceivable/updateMailReceivable',
      subscribe: 'companiesMailReceivable/subscribe',
      subscribeKeywordUsage: 'companiesMailReceivable/subscribeKeywordUsage',
      unsubscribe: 'companiesMailReceivable/unsubscribe',
      unsubscribeKeywordUsage: 'companiesMailReceivable/unsubscribeKeywordUsage',
      changeSubscription: 'companiesMailReceivable/changeSubscription',
      changeKeywordUsageSubscription: 'companiesMailReceivable/changeKeywordUsageSubscription',
      subscribeBlockGoogleUpdate: 'companiesMailReceivable/subscribeBlockGoogleUpdate',
      unsubscribeBlockGoogleUpdate: 'companiesMailReceivable/unsubscribeBlockGoogleUpdate',
      subscribeReport: 'companiesMailReceivable/subscribeReport',
      unsubscribeReport: 'companiesMailReceivable/unsubscribeReport',
      subscribeCustomSurveyStoreAnswer: 'companiesMailReceivable/subscribeCustomSurveyStoreAnswer',
      unsubscribeCustomSurveyStoreAnswer: 'companiesMailReceivable/unsubscribeCustomSurveyStoreAnswer',
      subscribeRpaError: 'companiesMailReceivable/subscribeRpaError',
      unsubscribeRpaError: 'companiesMailReceivable/unsubscribeRpaError',
      subscribeSnsApproval: 'companiesMailReceivable/subscribeSnsApproval',
      unsubscribeSnsApproval: 'companiesMailReceivable/unsubscribeSnsApproval',
      subscribePostApproval: 'companiesMailReceivable/subscribePostApproval',
      unsubscribePostApproval: 'companiesMailReceivable/unsubscribePostApproval',
      subscribeReplyApproval: 'companiesMailReceivable/subscribeReplyApproval',
      unsubscribeReplyApproval: 'companiesMailReceivable/unsubscribeReplyApproval',
    }),
    toggleViewMoreKeyword() {
      this.viewMoreKeyword = !this.viewMoreKeyword
    },
    displayWeekday(weekday) {
      return this.$t('labels.weekday.' + weekday)
    },
    onSubmit() {
      this.updateMailReceivable(this.currentCompanyUuid)
    }
  },
}
</script>

<style lang="scss" scoped>
.form {
  margin: 16px 0;
}

.selectForm {
  padding: 24px;
  &__info {
    margin-bottom: 8px;
    margin-left: -8px;
  }
}

.keywordItems {
  margin-bottom: 10px;
}
.achievementBox {
  margin-top: 24px;
  .c-checkbox {
    display: block;
    margin: 0;
  }
  .c-checkbox__item {
    display: flex;
    align-items: center;
    padding: 16px 0;
  }
  &__tooltip {
    margin-left: 12px;
  }
}
</style>
